import PropTypes from 'prop-types'
import { useState } from 'react'
import { Modal, Button } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { resetModal } from 'slices/modalSlice'
import { GenericGrid } from './GenericGrid'
import { GenericInputs } from './GenericInputs'
import { GenericItems } from './GenericItems'

export const GenericModal = ({
  onClose = () => {},
  onConfirm = () => {},
  onSelect = () => {},
  onChange = () => {},
  onAddItem = () => {},
  onRemoveItem = () => {},
  onCopyField = () => {}
}) => {
  const [submitting, setSubmitting] = useState(false)
  const dispatch = useDispatch()

  const { show, size, body, items, type, campos, errores, editMode, values, title } =
    useSelector((state) => state.genericModal)

  const handleConfirm = async () => {
    setSubmitting(true)
    const sinErrores = await onConfirm()
    if (!sinErrores) {
      setSubmitting(false)
      return
    }
    setSubmitting(false)
    handleClose()
  }

  const handleClose = () => {
    onClose()
    dispatch(resetModal())
  }

  return (
    <Modal show={show} onHide={handleClose} centered size={size}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <GenericItems
          items={items}
          body={body}
          onSelect={onSelect}
          onClose={handleClose}
        />
        <>
          {type === 'form' && (
            <>
              {campos.map((content) => {
                const value = values?.[content.name] ?? ''
                return (
                  !content.isGrid && (
                    <GenericInputs
                      key={content.name}
                      content={content}
                      value={value}
                      onChange={onChange}
                      errores={errores}
                      editMode={editMode}
                    />
                  )
                )
              })}
              <GenericGrid
                campos={campos}
                values={values}
                errores={errores}
                editMode={editMode}
                onAddItem={onAddItem}
                onRemoveItem={onRemoveItem}
                onChangeItem={onChange}
                onCopyField={onCopyField}
              />
            </>
          )}
        </>
      </Modal.Body>
      {(type === 'botones' || type === 'form') && (
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose} disabled={submitting}>
            Cancelar
          </Button>
          <Button variant="primary" onClick={handleConfirm} disabled={submitting}>
            {type === 'botones' ? 'Aceptar' : 'Guardar'}
          </Button>
        </Modal.Footer>
      )}
    </Modal>
  )
}

GenericModal.propTypes = {
  onChange: PropTypes.func,
  onClose: PropTypes.func,
  onConfirm: PropTypes.func,
  onSelect: PropTypes.func,
  onAddItem: PropTypes.func,
  onRemoveItem: PropTypes.func,
  onCopyField: PropTypes.func
}
